import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button as KubitButton } from '@kubit/web-ui-components/button';
import * as React from 'react';
import { ThirdPartyAnimationSizesType as LoaderSizesType } from '../../designSystem/reloaded/commons/components/variants';
import { Loader } from '../loader/loader';
export const Button = React.forwardRef((props, ref) => {
    const loaderSize = props.loader?.size || LoaderSizesType.EXTRA_SMALL;
    const loader = props.loader ? (_jsx("span", { role: "status", children: props.loading && _jsx(Loader, { ...props.loader, size: loaderSize }) })) : (_jsx(_Fragment, {}));
    return _jsx(KubitButton, { ...props, ref: ref, loader: loader });
});
Button.displayName = 'Button';
//# sourceMappingURL=button.js.map